export default "__VITE_ASSET__7256154b__"